import { useEffect, useMemo, useState } from 'react';

type Props = {
  gameNumber: number;
  gameName: string;
  reducedMotion: boolean;
  onFinished: () => void;
};

export function Countdown({ gameNumber, gameName, reducedMotion, onFinished }: Props) {
  const sequence = useMemo<Array<number | null>>(
    () => (reducedMotion ? [3, 2, 1] : [3, null, 2, null, 1, null]),
    [reducedMotion],
  );
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (step >= sequence.length) {
      onFinished();
      return;
    }
    const value = sequence[step];
    const duration = reducedMotion ? 100 : value === null ? 200 : 380;
    const handle = window.setTimeout(() => setStep((current) => current + 1), duration);
    return () => window.clearTimeout(handle);
  }, [onFinished, reducedMotion, sequence, step]);

  return (
    <section className="countdown" aria-live="polite">
      <p>
        Game {gameNumber} of 11: <strong>{gameName}</strong>
      </p>
      <div
        className="countdown-number"
        aria-label={sequence[step] ? `Starting in ${sequence[step]}` : undefined}
      >
        {sequence[step] ?? ''}
      </div>
    </section>
  );
}
